import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


import { environment } from '../../../environments/environment';
import { ResponseModel } from '../model/response.model';

@Injectable({
  providedIn: 'root'
})
export class ApiDataService {


  baseUrl = '';

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiurl;
  }



  getData(url: string): Observable<any> {
    return this.http.get(this.baseUrl + url)
      .pipe(map((response: ResponseModel<any>) => {
        return response;
      }));
  }


  postData(url: string, data: any): Observable<any> {
    return this.http.post(this.baseUrl + url, data)
      .pipe(map((response: ResponseModel<any>) =>
        response as any));
  }

  postDataArray(url: string, data: any[]): Observable<any> {
    return this.http.post(this.baseUrl + url, data)
      .pipe(map((response: ResponseModel<any>) =>
        response as any));
  }
}
